import { render } from "./adminlayout.vue?vue&type=template&id=4a2b0a3c&scoped=true"
import script from "./adminlayout.vue?vue&type=script&lang=js"
export * from "./adminlayout.vue?vue&type=script&lang=js"

import "./adminlayout.vue?vue&type=style&index=0&id=4a2b0a3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2b0a3c"]])

export default __exports__